import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";

import { numberToCurrency, computeProductName } from "../utility/global";

import MainShowWrap from "./MainShowWrap";
import SaveIconWrap from "./SaveIconWrap";
import ListIconWrap from "./ListIconWrap";

export default class ResultWrap extends Component {
    state = {
        isShowFailAddToCartWording: false,
    };

    componentDidUpdate(prevProps) {
        // 偵測 alreadyAddToCartList  批次加入購物車
        const {
            listData,
            postAddToCart,
            alreadyAddToCartList,
            readyAddToCartList,
            updateLoadingStatus,
            isShowAddToCartProductListModal,
        } = this.props;
        let productList = JSON.parse(JSON.stringify(readyAddToCartList));
        console.log(productList);
        if (prevProps.alreadyAddToCartList !== alreadyAddToCartList) {
            // console.log(alreadyAddToCartList.length, listData.length);
            if (
                alreadyAddToCartList.length !== listData.length &&
                productList.length !== 0
            ) {
                // 去除 splice， inplace method 會導致取下方 productList[0]取錯誤
                // 後來發現還是要加回去才會正常 work
                productList.splice(0, 1);
                if (productList.length !== 0) {
                    if (productList[0] !== undefined) {
                        postAddToCart(productList[0]);
                    }
                }
            } else {
                updateLoadingStatus(false);
            }
        }

        // 判斷是否要跳「加入購物車失敗」提示
        if (
            prevProps.isShowAddToCartProductListModal &&
            !isShowAddToCartProductListModal &&
            readyAddToCartList.length
        ) {
            this.setState({
                isShowFailAddToCartWording: true,
            });
        }
    }

    render() {
        const {
            // variable
            planningData,
            totalAmount,
            listData,
            readyAddToCartList,
            resetReadyAddToCartList,
            // function
            setSlideArray,
            // updateLoadingStatus,
            updateIsSendDesignCode,
            updateShowResultStatus,
            updateShowProductionListModal,
            updateShowPostProductionJsonModal,
            updateShowAddToCartProductListModal,
            postSaveStatusApi,
            postAddToCart,

            // 圖
            isShowResult,
            // CategoryData,
            selectedCategoryIndex,
            isReset,
            isGoToTheSamePosition,
            selectedState,
            gotoRow,
            resetSelected,
            updateSamePosition,
        } = this.props;
        const { isShowFailAddToCartWording } = this.state;
        return (
            <div className="result__wrap">
                <div className="row">
                    <div className="col-md-12 col-lg-6 p-0 position-relative">
                        <div className="blankOver"></div>
                        {!planningData ? null : !planningData.category ? null : !planningData
                              .category[selectedCategoryIndex] ? null : (
                            <MainShowWrap
                                isShowResult={isShowResult}
                                planningData={planningData}
                                CategoryData={
                                    planningData.category[selectedCategoryIndex]
                                }
                                setSlideArray={setSlideArray}
                                SelectedCategoryFacets={
                                    planningData.category[selectedCategoryIndex]
                                        .categoryList
                                }
                                // 選到第幾個分類
                                selectedCategoryIndex={selectedCategoryIndex}
                                // 該分類現在顯示為第幾個
                                selectedState={selectedState}
                                isReset={isReset}
                                resetSelected={resetSelected}
                                isGoToTheSamePosition={isGoToTheSamePosition}
                                updateSamePosition={updateSamePosition}
                                gotoRow={gotoRow}
                            />
                        )}
                    </div>
                    <div className="col-md-12 col-lg-6 ">
                        <div className="title pt-3">
                            {computeProductName(
                                listData,
                                selectedCategoryIndex,
                                planningData
                            )}
                        </div>
                        <div className="iconWrap">
                            <div
                                className="save__wrap"
                                onClick={(e) => {
                                    postSaveStatusApi(
                                        selectedCategoryIndex,
                                        selectedState
                                    );
                                    updateShowPostProductionJsonModal(true);
                                }}>
                                <SaveIconWrap />
                            </div>
                            <div
                                className="list__wrap"
                                onClick={(e) => {
                                    updateShowProductionListModal(true);
                                }}>
                                <ListIconWrap
                                    updateShowProductionListModal={
                                        updateShowProductionListModal
                                    }
                                />
                            </div>
                        </div>
                        <div className="amount__wrap">
                            {numberToCurrency(totalAmount)}
                        </div>
                        <button
                            className="addToCart__wrap btn"
                            disabled={
                                isShowFailAddToCartWording
                                    ? true
                                    : readyAddToCartList.length === 0
                                    ? true
                                    : false
                            }
                            onClick={(e) => {
                                postAddToCart(readyAddToCartList[0]);
                                updateShowAddToCartProductListModal(true);
                                // updateLoadingStatus(true)
                            }}>
                            <FontAwesomeIcon icon={faShoppingCart} />
                            {readyAddToCartList.length === 0
                                ? "已經加入購物車"
                                : "加入購物車"}
                        </button>
                        {isShowFailAddToCartWording ? (
                            <div class="text-danger">
                                部分商品加入購物車失敗
                            </div>
                        ) : null}
                        <div
                            className="redesign__wrap"
                            onClick={(e) => {
                                updateShowResultStatus(false);
                                updateIsSendDesignCode(false);
                                resetReadyAddToCartList();
                            }}>
                            重新設計
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
